import { render } from "./GraphCard.vue?vue&type=template&id=484e9220&scoped=true"
import script from "./GraphCard.vue?vue&type=script&lang=js"
export * from "./GraphCard.vue?vue&type=script&lang=js"

import "./GraphCard.vue?vue&type=style&index=0&id=484e9220&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-484e9220"]])

export default __exports__